import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

/**
 * Slim re-accept banner shown to logged-in users when site_settings has been
 * bumped past their last-accepted Terms or Privacy version.
 *
 * Hidden when:
 *   - user is not logged in (no auth token)
 *   - server can't be reached (fail open — don't block the storefront)
 *   - user's accepted versions match current
 *
 * One click POSTs the accepted versions back; banner self-dismisses on success.
 */
export default function LegalReacceptBanner() {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch('/api/users/me/legal-status', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(setStatus)
      .catch(() => {});
  }, []);

  if (!status) return null;
  if (!status.needsTermsAccept && !status.needsPrivacyAccept) return null;

  async function accept() {
    setBusy(true);
    const token = localStorage.getItem('token');
    try {
      await fetch('/api/users/me/accept-legal', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          terms:   status.needsTermsAccept   ? status.currentTerms   : undefined,
          privacy: status.needsPrivacyAccept ? status.currentPrivacy : undefined,
        }),
      });
      setStatus({ ...status, needsTermsAccept: false, needsPrivacyAccept: false });
    } catch (_) {}
    setBusy(false);
  }

  const items = [];
  if (status.needsTermsAccept)   items.push(<Link key="t" to="/terms"   target="_blank" style={{ color: '#fff', textDecoration: 'underline' }}>updated Terms</Link>);
  if (status.needsPrivacyAccept) items.push(<Link key="p" to="/privacy" target="_blank" style={{ color: '#fff', textDecoration: 'underline' }}>updated Privacy Policy</Link>);

  return (
    <div role="status" style={{
      background: '#0d5c3a', color: '#fff',
      padding: '10px 16px', fontSize: 14,
      display: 'flex', gap: 14, alignItems: 'center', flexWrap: 'wrap',
    }}>
      <span style={{ flex: 1 }}>
        We've updated our {items.length === 2 ? <>{items[0]} and {items[1]}</> : items[0]}. Please review and accept to continue.
      </span>
      <button
        onClick={accept}
        disabled={busy}
        style={{
          background: '#ffde00', color: '#111',
          border: 'none', borderRadius: 6,
          padding: '6px 14px', fontWeight: 700, cursor: 'pointer', fontSize: 13,
        }}
      >{busy ? 'Saving…' : 'I agree'}</button>
    </div>
  );
}
